import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core'
import moment from 'moment'
import { MachineStateComputed } from '../../../..//models/states-computed.models'
import { TouaregControlStateHealthMonitorService } from '../../../..//services/touareg-control-state-health-monitor.service'

const MICRO_DELAY = 10 // ms
const MOUNT_DELAY = 200 // ms

@Component({
  selector: 'app-touareg-control-progress-button',
  templateUrl: './touareg-control-progress-button.component.html',
  styleUrls: ['./touareg-control-progress-button.component.scss'],
  imports: [],
})
export class TouaregControlProgressButtonComponent implements AfterViewInit {
  @Output()
  complete = new EventEmitter<boolean>()

  @Output()
  click = new EventEmitter<any>()

  @Input()
  disabled: boolean = false

  @Input()
  set state(s: MachineStateComputed) {
    this._initState(s)
  }

  @ViewChild('progressBar') progressBar!: ElementRef
  @ViewChild('progressShape') progressShape!: ElementRef

  public el: any

  private _state: MachineStateComputed | undefined
  private _waiting: { func: Function } | null = null
  private _timeout: any
  private _timeoutEnd: any
  private _hasInit: boolean = false
  private _duration: number = 0

  constructor(private _monitor: TouaregControlStateHealthMonitorService) {}

  ngAfterViewInit(): void {
    // Reset des styles
    this.el = this.progressBar.nativeElement
    this.el.style.opacity = 0
    this.el.style.width = 0
    this._hasInit = true

    // Timeout pour lancer le re-calcul des styles
    // Nécessaire ici car le setter this.state a pu déjà être appelé avant que le DOM soit prêt
    setTimeout(() => {
      this._processInternalDuration()
    }, MOUNT_DELAY)
  }

  private _initState(state: MachineStateComputed) {
    // Nettoyage
    if (!state?.countdown || !state.countdown_start_date) {
      this._clear()
      return
    }

    // Si on est dans un nouveau countdown
    // On lance le nouveau sablier
    if (
      !this._duration ||
      state?.countdown_start_date !== this._state?.countdown_start_date
    ) {
      this._storeInternalDuration(state)
      this._processInternalDuration()
    }

    // Stockage du state
    this._state = state
  }

  private _clearTimeouts() {
    if (this._timeout) {
      clearTimeout(this._timeout)
      this._timeout = null
    }

    if (this._timeoutEnd) {
      clearTimeout(this._timeoutEnd)
      this._timeoutEnd = null
    }
  }

  private _clear() {
    this._clearTimeouts()
    this._duration = 0
    if (this.el) {
      this.el.style.opacity = 0
      this.el.style.transition = ''
    }
  }

  private _processInternalDuration() {
    this._clearTimeouts()

    if (this._hasInit && this._waiting) {
      this._waiting.func()
    }
  }

  private _setValues(state: MachineStateComputed) {
    // On récupère les metrics
    // => offset d'horloge device/server
    // => stateUpdateScore: contient la moyenne
    // const { dateOffset, stateUpdateScore } = this._monitor.health
    const { pingScore } = this._monitor.health

    // Api start date
    const countdown_start_date = state.countdown_start_date!.valueOf()
    const countdown = state.countdown!
    // Calcul de la date de fin supposée
    const countdown_ui_end_date =
      countdown_start_date + countdown * 1000 - (pingScore?.average ?? 0)
    // Calcule de la durée du countdown
    this._duration = countdown_ui_end_date - moment().valueOf()

    // // Différence entre la date de calcul de l'état
    // // et la date de réception de l'état
    // let countDiff = dayjs().diff(state.countdown_start_date, 'ms')

    // // Logs
    // console.log('-----------------')
    // console.log('Initial Hourglass Picture')
    // console.log('Countdown diff state update', countDiff)

    // // On ajoute (on retire de la diff) le delay moyen entre la date de cacul
    // // et la date de réception
    // if (stateUpdateScore?.average) {
    //   countDiff -= stateUpdateScore.average
    //   console.log('State update average', stateUpdateScore.average)
    //   console.log('Countdown diff MINUS state update average', countDiff)
    // }

    // // On redresse la diff par le décalage d'horloge
    // if (dateOffset) {
    //   countDiff += dateOffset
    //   console.log('Date offset', dateOffset)
    //   console.log('Countdown diff after dateOffset', countDiff)
    // }

    // // On calcule la durée UI du countdown en ms
    // this._duration = state.countdown * 1000 - countDiff
    // console.log('Final duration', this._duration)

    //this._duration = this._baseDuration - relativeCountDiff / 1000
  }

  private _storeInternalDuration(state: MachineStateComputed) {
    this._waiting = {
      func: () => {
        this._setValues(state)

        // Reset des styles
        this.el.style.transition = ''
        this.el.style.width = '0'
        this.el.style.opacity = 1

        // Préparation de la modif des styles
        this._timeout = setTimeout(() => {
          this.el.style.width = '100%'
          this.el.style.transition = `width ${this._duration}ms linear`
          this._waiting = null

          // Reset du timeout complete
          if (this._timeoutEnd) {
            clearTimeout(this._timeoutEnd)
            this._timeoutEnd = null
          }

          // Mise en place du nouveau timeout complete
          this._timeoutEnd = setTimeout(() => {
            this.complete.emit(true)
          }, this._duration)
        }, MICRO_DELAY)
      },
    }
  }

  onClick($event: MouseEvent) {
    this.click.emit($event)
  }

  ngOnDestroy(): void {
    this._clearTimeouts()
  }
}
